<template>

  <div class="home-wrap">
    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          走进碳索
        </div>
        <div @click="qiehuanTab(index)" :class="currTab == index ?'item-txt item-txt-select':'item-txt'"
             v-for="(txt, index) in menuList">
          {{ txt.text }}
        </div>
      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > 走进碳索 > {{ menuList[currTab].text }}
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <template v-if="currTab==0">

          <img style="margin-top: 20px" src="../../../assets/imgs/about-us-ic.png">

          <!--          <p class="content-p">-->
          <!--            碳索（杭州）能源环境科技有限公司位于风景优美、交通便利的高端科技研发集聚地——浙江省杭州市青山湖科技城，毗邻浙江大学青山湖能源研究基地、香港大学浙江科学技术研究院等高等学府。公司以专业、专注的理念持续深耕清洁低碳能源体系建设，先后与浙江大学、清华大学、东南大学、北京化工大学、四川大学、天津大学等17个院所开展深度合作，在碳减排、大宗工业固废处理、废气治理等面取得突破进展，并致力于开展节能环保新技术产、学、研一体化项目建设。-->
          <!--          </p>-->
          <!--          <p class="content-p">-->
          <!--            公司以“瞄准能源学科技术前沿-->
          <!--            提供低碳环保解决方案”为宗旨，紧盯行业发展前沿并积极对接企业技术需求，以自主核心研发团队为基础，并紧密依托国内高校及院所研究资源，以专业、成熟的产学研结合模式，为低碳环保、绿色循环发展提供技术动力。目前核心技术研发团队有教授、研究员、教授级高级工程师及博士后、博士、硕士20余人，相关配套专业工程设计人员、工程技术人员30余人，研发团队取得并可授权使用专利30余项。公司对接各大高校、科研院所和国内各类型企业，专业从事技术咨询、工艺开发、工艺包开发、新工艺新技术新工程项目初步设计、新装置设计及建设、EPC一体化项目建设、技术升级改造及成果推广及转化等工作。-->
          <!--          </p>-->

          <!--          <p class="content-p">-->
          <!--            公司先后承担了国家重大科技研发专项CO2捕集示范项目—-国华锦能年产15万吨/年CO2捕集项目制订了核心工艺；国家重大科技研发专项千吨级/年烟气CO2吸附工业验证装置设计、采购（EP）项目；浙能研究院燃煤电厂烟气CO2捕集中试项目；中国华电电科院燃气电厂烟气CO2-->
          <!--            捕集及3万吨干冰项目；金隅集团5万吨水泥窑烟气CO2捕集项目；河北诚峰热电5万吨热电厂燃烧后烟气CO2捕集项目等。工业固废电石渣制备纳米级碳酸钙项目已通过年产一千吨纳米钙中试，-->
          <!--            5万吨工业化示范验证项目正在进行；国家重大研发专项万吨级CO2矿化养护混凝土示范工程已经通过验证。-->
          <!--          </p>-->

          <!--          <p class="content-p">公司将继续秉承专业、高效的服务理念为客户提供咨询、研发、设计、施工及改造等一体化服务。</p>-->
          <!--          <p class="content-p">面向未来，公司将继续以 “探索低碳能源体系-->
          <!--            引领绿色循环发展”为己任，致力于能源环保科技的开发和产业化应用，以技术为核心、视品质如生命、充分发挥公司人才优势、技术优势，竭诚为客户提供专业、优质、高品质的服务。</p>-->


        </template>
        <template v-if="currTab==1">

          <div class="yfpt-w">
            <img src="../../../assets/imgs/white-top.png">
            <div class="title">企业文化</div>
          </div>

          <!--          <p class="content-p">-->
          <!--            企业标语：探索低碳 回馈自然-->
          <!--          </p>-->

          <!--          <p class="content-p">-->
          <!--            经营理念：清洁低碳能源技术方案和服务专业集成商。-->
          <!--          </p>-->

          <!--          <p class="content-p">-->
          <!--            企业宗旨： 专业 专注 深耕清洁低碳能源技术平台。-->
          <!--          </p>-->

          <!--          <p class="content-p">-->
          <!--            企业精神：瞄准能源学科技术前沿 提供低碳环保解决方案。-->
          <!--          </p>-->
          <!--          <p class="content-p">-->
          <!--            企业愿景：探索低碳能源体系 引领绿色循环发展。-->
          <!--          </p>-->
        </template>

        <div id="pp" class="content-pp">

        </div>
        <div style="height: 40px"></div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from "jquery";

export default {
  name: "aboutUsFragment",
  data: () => {

    return {
      currTab: 0,
      menuList: [{
        text: '公司简介',
      }, {
        text: '企业文化',
      }]
    }
  },
  mounted() {
    $("#pp").empty()
    $("#pp").append(this.$store.state.homeTs[1].detail)
  },
  watch: {
    currTab(vv) {
      $("#pp").empty()
      if (vv == 0) {
        $("#pp").append(this.$store.state.homeTs[1].detail);
      } else {
        $("#pp").append(this.$store.state.homeTs[2].detail);
      }
    }
  },
  methods: {
    goHome() {
      this.$router.replace('/home')
    },
    qiehuanTab(i) {
      this.currTab = i
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap {

  display: flex;
  width: 1400px;
  min-width: 100%;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 100%;
  }

}

.contact-us-wrap {
  width: min-content;
  min-height: 100%;
  padding-top: 10px;
  min-width: 100%;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }

    .content-p {
      width: 100%;
    }

    .yfpt-w {
      width: 100%;
      background-image: linear-gradient(to right, #1565A8, #84B2EF);
      position: relative;
      display: flex;
      margin-top: 20px;
      flex-direction: column;

      img {
        top: 20px;
        left: 30px;
        position: absolute;
      }

      .title {
        margin-left: 45px;
        color: white;
        margin-right: 20px;
        margin-bottom: 20px;
        margin-top: 40px;
        font-size: 18px;
      }
    }

    .content-p {
      text-indent: 2em;
      font-size: 16px;
      color: #333333;
      margin-top: 10px;
      width: 100%;

    }
  }
}
</style>
